import React from 'react'
import PropTypes from 'prop-types'

const SkillCard = ({ title, skills }) => {
  return (
    <div className="skills__content">
      <div className="skills__title">{title}</div>
      <div className="skills__box">
        <div className="skills__group">
          {skills.slice(0, Math.ceil(skills.length / 2)).map((skill) => (
            <div className="skills__data" key={skill.name}>
              <i className='bx bx-badge-check'></i>
              <div>
                <h3 className="skills__name">{skill.name}</h3>
                <span className="skills__level">{skill.level}</span>
              </div>
            </div>
          ))}
        </div>
        <div className="skills__group">
          {skills.slice(Math.ceil(skills.length / 2)).map((skill) => (
            <div className="skills__data" key={skill.name}>
              <i className='bx bx-badge-check'></i>
              <div>
                <h3 className="skills__name">{skill.name}</h3>
                <span className="skills__level">{skill.level}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

SkillCard.propTypes = {
  title: PropTypes.string.isRequired,
  skills: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      level: PropTypes.string.isRequired,
    })
  ).isRequired,
}

export default SkillCard
